import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService, SelectItem } from 'primeng/api';
import { HttphelperService } from 'src/app/core/services/helpers/httphelper.service';
import { BreadcrumbService } from 'src/app/core/services/navigation/breadcrumb.service';
import { IAppointment } from 'src/app/models/IAppointment';

@Component({
  selector: 'app-doctor-appointments',
  templateUrl: './doctor-appointments.component.html',
  styleUrls: ['./doctor-appointments.component.scss']
})
export class DoctorAppointmentsComponent implements OnInit {

  dateCriteria: SelectItem[];
  selectedDate:any;
  dir='ltr';

  doctorAppointments:IAppointment[];
  cols: any[];
  isLoading:boolean;
  days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  satDate:string='';
  sunDate:string='';
  monDate:string='';
  tuesDate:string='';
  wedDate:string='';
  thurDate:string='';
  firdDate:string='';

  selectedCustomDate:any;
  isDisableCustomDate :boolean = true;

  _loadAllData:boolean = false;
  @Input() set loadAllData(value:boolean){
    this._loadAllData = value;
    if(value == true){
      this.selectedCustomDate = this.breadSer.callQueue.AppointmentDate;
      this.loadDateCriteria();
      this.SetColHeadersWithDates();
      this.loadDoctorAppointmentsData();
    }
  }
  constructor(private helperService:HttphelperService,private messageService: MessageService,public breadSer:BreadcrumbService,
    private cd:ChangeDetectorRef,private translate: TranslateService) {
    }

  ngOnInit(): void {
    let currentLnaguage =  localStorage.getItem('lang');
    if(currentLnaguage == null){
        this.dir = "ltr"; 
    }
    else
    {
      if(currentLnaguage == 'ar'){
        this.dir = "rtl"; 
      }
      else{
       this.dir = "ltr"; 
      }
    }
    this.cols = [
      {field: 'SpecialtyName', header: 'التخصص'},
      {field: 'PersonNameA', header: 'الدكتور'},
      {field: 'Saturday', header: 'السبت'},
      {field: 'Sunday', header: 'الاحد'},
      {field: 'Monday', header: 'الاثنين'},
      {field: 'Tuesday', header: 'الثلاثاء'},
      {field: 'Wednesday', header: 'الاربعاء'},
      {field: 'Thursday', header: 'الخميس'},
      {field: 'Friday', header: 'الجمعه'}
    ];
    this.selectedDate = "2";
  }
  changeDateCriteria(){
    if(this.selectedDate == 4)
    {
      this.isDisableCustomDate = false;
    }
    else
    {
      this.isDisableCustomDate = true;
    }
    this.SetColHeadersWithDates();
    this.doctorAppointments = [];
  }
  selectDateCustom(){
    this.doctorAppointments = [];
    this.SetColHeadersWithDates();
  }
  loadDateCriteria()
  {
    this.dateCriteria = [
      { label: "Day", value: "1"},
      { label: "Current Week", value: "2" },
      { label: "Next Week", value: "3" },
      { label: "Custom", value: "4" }
    ];
    this.translateItems(this.dateCriteria);
  }
  loadDoctorAppointmentsData()
  {
    this.isLoading = true;
    this.cd.detectChanges();
    var doctorAppointmentUrl = `/api/Queue/GetDoctorAppointments?specialtyId=${this.breadSer.specialtyId}&doctorId=${this.breadSer.callQueue.ProviderID}&dateCriteria=${+this.selectedDate}&customDateStr=${this.selectedCustomDate.toLocaleDateString()}`;
    this.helperService.getRequest(doctorAppointmentUrl).subscribe(response => {
      this.doctorAppointments = response?.Data;
      if(response.Success)
      {
        if(this.doctorAppointments.length == 0)
        {
          this.messageService.add({severity: 'warn', summary: 'تحذير', detail:"لا يوجد مواعيد متاحه", life: 2000});
        }
      }
      else
      {
          this.messageService.add({severity: 'error', summary: 'خظأ', detail:response.Message, life: 2000});
      }   
      this.isLoading = false;
    },
    error=>{
      this.messageService.add({severity: 'error', summary: 'خظأ', detail: error, life: 2000});
      this.isLoading = false;
    })
  }
  SetColHeadersWithDates(){
    var firstDay;
    var lastDay;

    var currentDate = new Date(this.selectedCustomDate);
    if(this.selectedDate == 1 || this.selectedDate == 2){
      //first = currentDate.getDate() - currentDate.getDay() - 1; // First day is the day of the month - the day of the week
      
      firstDay = new Date(currentDate.setDate(currentDate.getDate() - currentDate.getDay() -1));
      lastDay = new Date(currentDate.setDate(currentDate.getDate() - currentDate.getDay() + 6));
    }
    else if(this.selectedDate == 3){
      //first = currentDate.getDate() - currentDate.getDay() + 6; // First day is the day of the month - the day of the week
      firstDay = new Date(currentDate.setDate(currentDate.getDate() - currentDate.getDay() + 6));
      lastDay = new Date(currentDate.setDate(currentDate.getDate() - currentDate.getDay() + 6));
    }
    else if(this.selectedDate == 4){
      var dayName = this.days[currentDate.getDay()];
      if(dayName == 'Saturday'){
        firstDay = currentDate;
      }else{
        firstDay = new Date(currentDate.setDate(currentDate.getDate() - currentDate.getDay() -1));
      }
      lastDay = new Date(currentDate.setDate(currentDate.getDate() - currentDate.getDay() + 6));
    }
    var monthNumber = firstDay.getMonth() + 1;
    this.satDate = " ("+firstDay.getDate()+"/"+monthNumber+") ";
    
    var sunDate= new Date(firstDay);
    sunDate.setDate(sunDate.getDate() + 1);
    var sunDateMonth = sunDate.getMonth() + 1;
    this.sunDate = " ("+(sunDate.getDate())+"/"+sunDateMonth+") ";

    var monDate = new Date(firstDay);
    monDate.setDate(monDate.getDate() + 2);
    var monDateMonth = monDate.getMonth() + 1;
    this.monDate = " ("+(monDate.getDate())+"/"+monDateMonth+") ";

    var tuesDate = new Date(firstDay);
    tuesDate.setDate(tuesDate.getDate() + 3);
    var tuesDateMonth = tuesDate.getMonth() + 1;
    this.tuesDate = " ("+(tuesDate.getDate())+"/"+tuesDateMonth+") ";

    var wedDate = new Date(firstDay);
    wedDate.setDate(wedDate.getDate() + 4);
    var wedDateMonth = wedDate.getMonth() + 1;
    this.wedDate = " ("+(wedDate.getDate())+"/"+wedDateMonth+") ";

    var thursDate = new Date(firstDay);
    thursDate.setDate(thursDate.getDate() + 5);
    var thurDateMonth = thursDate.getMonth() + 1;
    this.thurDate = " ("+(thursDate.getDate())+"/"+thurDateMonth+") ";

    var fridDate = new Date(firstDay);
    fridDate.setDate(fridDate.getDate() + 6);
    var fridDateMonth = fridDate.getMonth() + 1;
    this.firdDate = " ("+(fridDate.getDate())+"/"+fridDateMonth+") ";
  }
  translateItems(items:any[]){
    for(let i=0; i<items.length; i++){
        this.translate.get(items[i].label).subscribe(res=>{
            items[i].label = res;
            if(items[i].items != undefined){
                this.translateItems(items[i].items);
            }
        })
      }
  }
}
